import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Grid,
  Card,
  CardContent,
  Typography,
  CardActionArea,
  CircularProgress,
  Box,
  Tooltip,
  Stack
} from "@mui/material";
import axios from "axios";
import { Toaster, } from 'react-hot-toast';
import ImageCarousel from "components/ImageCarousal";

const LocationIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z" />
    <circle cx="12" cy="10" r="3" />
  </svg>
);

const PeopleIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75" />
  </svg>
);

const TimeIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="12" cy="12" r="10" />
    <polyline points="12 6 12 12 16 14" />
  </svg>
);

const StudentFacilities = () => {
  const navigate = useNavigate();
  const [sortColumn, setSortColumn] = useState('facility_name');
  const [sortOrder, setSortOrder] = useState('asc');
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  // const [hoveredId, setHoveredId] = useState(null);
  const itemsPerPage = 5;
  // const options = { year: 'numeric', month: '2-digit', day: '2-digit' };


  const fetchFacilities = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(
        "https://api.nvcti.in/facilities/getAllFacilities",
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.data.success) {
        throw new Error(response.data.message || "Failed to fetch facilities");
      }

      const formattedFacilities = response.data.data.map((facility) => ({
        id: facility.facility_id,
        facility_name: facility.facility_name,
        location: facility.location,
        capacity: facility.capacity,
        description: facility.description,
        slots_timing: facility.slots_timing,
        start_time: facility.start_time,
        end_time: facility.end_time,
        facility_images: facility.facility_images,
        image:
          facility.image_url ||
          "https://ismaana.org/wp-content/uploads/2023/02/naresh-center-02.jpg", // Replace with actual image URL if available
      }));

      setData(formattedFacilities);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching facilities:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFacilities();
  }, []);

  const filteredData = data.filter(item =>
    item.facility_name.toLowerCase().includes(searchTerm.toLowerCase())
    //item.created_by.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const sortedData = [...filteredData].sort((a, b) => {
    const comparison = a[sortColumn].localeCompare(b[sortColumn]);
    return sortOrder === 'asc' ? comparison : -comparison;
  });

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  // const currentItems = sortedData.slice(indexOfFirstItem, indexOfLastItem);
  // const totalPages = Math.ceil(filteredData.length / itemsPerPage);

  // const handleSort = (column) => {
  //   setSortOrder(prevOrder => (sortColumn === column && prevOrder === 'asc' ? 'desc' : 'asc'));
  //   setSortColumn(column);
  // };

  // function parseTimeToMinutes(timeStr) {
  //   const [hours, minutes, seconds = 0] = timeStr.split(':').map(Number);
  //   return hours * 60 + minutes + seconds / 60;
  // }

  const handleCardClick = (id, name, endTime, facility) => {
    // const now = new Date();
    // const currentTimeStr = now.toTimeString().slice(0, 5);
    // const currentMinutes = parseTimeToMinutes(currentTimeStr);
    // const endMinutes = parseTimeToMinutes(endTime);

    // if(currentMinutes > endMinutes ){
    //   toast.error("The Registration for this Facility is Closed.")
    // }else{
    navigate(`/student/facility-reservation`, { state: { type: "create", fid: id, fname: name, formValues: null, facility } });
    // }
  };

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="80vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <>
      <Toaster position="top-left" reverseOrder={false} />
      <div className="relative w-full">
        <div className="flex justify-between items-center px-4 mt-6">
          <p className="font-semibold text-lg text-white">Facilities</p>
          <div className="flex">
            {/* Search can be added back here if needed */}
          </div>
        </div>

        <div className="px-6 mt-4 mb-6">
          <form className="flex flex-row flex-wrap items-center">
            <div className="relative flex w-full flex-wrap items-stretch">
              <span className="z-10 h-full leading-snug font-normal absolute text-center text-blueGray-900 bg-transparent rounded text-base items-center justify-center w-8 pl-3 py-3">
                <i className="fas fa-search"></i>
              </span>
              <Tooltip title="Search Record" arrow>
                <input
                  type="text"
                  placeholder="Search by Facility Name/Amount"
                  className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:ring w-full pl-10 pr-10"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </Tooltip>
              {searchTerm && (
                <button
                  type="button"
                  onClick={() => setSearchTerm("")}
                  className="absolute right-0 top-0 bottom-0 flex items-center justify-center w-10 text-blueGray-900 hover:text-blueGray-600 focus:outline-none"
                >
                  <i className="fas fa-times"></i>
                </button>
              )}
            </div>
          </form>
        </div>

        <Grid container spacing={4}>
          {filteredData.map((facility) => (
            <Grid item xs={12} sm={6} md={4} key={facility.id}>
              <Card sx={{ borderRadius: 3, boxShadow: 3 }}>
                <CardActionArea >
                  {/* <CardMedia
                    component="img"
                    height="160"
                    image={facility.image}
                    alt={facility.facility_name}
                  /> */}
                  <ImageCarousel images={facility.facility_images} />

                  <CardContent onClick={() => handleCardClick(facility.id, facility.facility_name, facility.end_time, facility)}>
                    <Typography
                      gutterBottom
                      variant="h6"
                      component="div"
                      sx={{ fontWeight: 600, textTransform: 'capitalize' }}
                    >
                      {facility.facility_name}
                    </Typography>

                    <Stack
                      direction="row"
                      spacing={1}
                      alignItems="center"
                      sx={{ mb: 0.5 }}
                    >
                      <LocationIcon fontSize="small" color="action" />
                      <Typography variant="body2" color="text.secondary">
                        {facility.location}
                      </Typography>
                    </Stack>

                    <Stack
                      direction="row"
                      spacing={1}
                      alignItems="center"
                      sx={{ mb: 0.5 }}
                    >
                      <PeopleIcon fontSize="small" color="action" />
                      <Typography variant="body2" color="text.secondary">
                        Capacity: {facility.capacity}
                      </Typography>
                    </Stack>

                    <Stack
                      direction="row"
                      spacing={1}
                      alignItems="center"
                      sx={{ mb: 0.5 }}
                    >
                      <TimeIcon fontSize="small" color="action" />
                      <Typography variant="body2" color="text.secondary">
                        Slots: {facility.start_time} - {facility.end_time}
                      </Typography>
                    </Stack>

                    <Stack direction="row" spacing={1} alignItems="flex-start">

                      <Typography variant="body2" color="text.secondary"
                        style={{ maxHeight: "100px" }}
                        className="max-h-[100px] overflow-y-auto scrollbar-thin "
                      >
                        {facility.description}
                      </Typography>
                    </Stack>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          ))}
        </Grid>
      </div>
    </>
  );
};

export default StudentFacilities;
